module.exports = __webpack_public_path__ + "static/apple-store-8a5d4a081d2a8203fe4938c75037942d.png";